import { useState } from 'react';

import { clipboardWrite } from '../utils/text/clipboard';

export default function useCopyOnClick(
  text: string,
  onClick?: (value: string) => void,
  onError?: (e: Error) => void,
): [boolean, () => Promise<void>] {
  const [justCopied, setJustCopied] = useState(false);
  const click = async () => {
    try {
      clipboardWrite(text);
      setJustCopied(true);
      setTimeout(() => {
        setJustCopied(false);
      }, 2000);
      onClick && onClick(text);
    } catch (err) {
      console.warn(err);
      onError && onError(err);
    }
  };

  return [justCopied, click];
}
